import apiClient from "./config";
import { SALARIES_ENDPOINTS } from "./endpoints";

const salariesService = {
    // Get Search Results
    getSalaries: (data) => {
        return apiClient.post(SALARIES_ENDPOINTS.SALARIES, data);
    },
    publicGetSalaries: (data) => {
        return apiClient.post(SALARIES_ENDPOINTS.PUBLIC_SALARIES, data);
    },
    // Today's free-tier input-change usage for the salary page.
    usage: () => {
        return apiClient.get(SALARIES_ENDPOINTS.USAGE);
    },
    // Distinct states available in the hospital salary table.
    getStates: () => {
        return apiClient.get(SALARIES_ENDPOINTS.STATES);
    },
};

export default salariesService;